import { createSelector } from "reselect";
import { memoize, uniqueByKey } from "@ls/js-utils";
import SelectionState from "state/selections/SelectionState";
import scope from "./scope";

export const selectDefinitions = memoize((selectionState) => {
  if (selectionState === SelectionState.UNCOMMITTED) {
    return (state) => state[scope]["definitions"][selectionState];
  }

  return createSelector(
    (state) => state[scope]["definitions"][selectionState],
    (definitions) => {
      const completeDefinitions = definitions.filter(
        ({ complete }) => complete
      );
      return completeDefinitions.filter(
        uniqueByKey(completeDefinitions, "key")
      );
    }
  );
});

export const selectFetchingTradeStrategyGroups = (state) =>
  state[scope].fetchingTradeStrategyGroups;
export const selectTradeStrategyGroups = (state) =>
  state[scope].tradeStrategyGroups;
export const selectFetchingTradeStrategies = (state) =>
  state[scope].fetchingTradeStrategies;
export const selectTradeStrategies = (state) => state[scope].tradeStrategies;
export const selectCovarMatrixTypes = (state) => state[scope].covarMatrixTypes;
export const selectErrorTypes = (state) => state[scope].errorTypes;
export const selectTradeTrackingErrorFields = (state) => state[scope].fields;
export const selectTradeTrackingErrorData = (state) => state[scope].data;
export const selectFetchingTradeTrackingErrorData = (state) =>
  state[scope].fetchingData;
export const selectRowsMap = createSelector(
  selectTradeTrackingErrorData,
  selectDefinitions(SelectionState.COMMITTED),
  selectTradeTrackingErrorFields,
  (tradeTrackingErrorData, selectedDefinitions, fields) => {
    const rowsMap = {};
    selectedDefinitions.forEach((definition) => {
      (tradeTrackingErrorData[definition.key] || []).forEach((tteData = {}) => {
        const { accountId } = tteData;
        if (!rowsMap[accountId]) {
          rowsMap[accountId] = {};
        }
        fields.forEach((field) => {
          const rowKey = `${definition.key},${field}`;
          if (!rowsMap[accountId][rowKey]) {
            rowsMap[accountId][rowKey] = {};
          }
          rowsMap[accountId][rowKey] = tteData[field];
        });
      });
    });
    return rowsMap;
  }
);
